// extracted by mini-css-extract-plugin
export default {"Bold":"gyoCz_Xb"};